export { TRANSITION_DURATION, Content, HeaderWrapper, BodyWrapper, Body, Footer, PopUp } from "./PopUp";